import styled from 'styled-components';

const RadioWrap = styled.div`
  display: flex;
  margin-top: var(--cc_size_spacing_s);
`;

export default RadioWrap;
